export default __webpack_public_path__ + "static/media/317.ed6d7b2f.png";